// extracted by mini-css-extract-plugin
export default {"root":"classes_root__4pR61","input":"classes_input__PQLk2"};